import Login from "@/auth/Login";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_unauthenticated/login")({
  component: Login,
});
